export abstract class CrmOfferLoaderRequestParamsBaseService {
    abstract get params(): any | undefined;
}
